import React from 'react'
import { JobWizardMobile } from 'sprockets_react/job_wizards/registries'

JobWizardMobile.NavigationButtons = function(props) {
  const { onStepProgression, onStepRetreat, navButtonLayout, onSecondaryNavButtonClick, onModalExit } = props
  const { leftButton, rightButton } = props.buttons || {}
  const label = props.label || ''
  const layoutChooser = {
    'submitButton'   :  submitButton,
    'okButton'       :  okButton,
    'exitButton'     :  exitButton,
    'skipButton'     :  skipButton,
    'upButton'       :  upButton,
    'downButton'     :  downButton,
    'upAndDownButton':  upAndDownButton,
    'submitClosureButton': submitClosureButton,
    'none': () => null,
    'default': () => null
  }

  function submitButton() {
    return (
      <div className="row">
        <div className="col-xs-12">
          <a href="#" id="modal-nav-one-button" className="btn btn-block btn-main" onClick={onStepProgression}>
            Submit
          </a>
        </div>
      </div>
    )
  }

  function submitClosureButton() {
    return (
      <div className="row">
        <div className="col-xs-6">
          <a href="#" id="modal-nav-one-button" className="btn btn-block btn-main" style={{'whiteSpace': 'normal'}} onClick={onStepRetreat}>
            Back
          </a>
        </div>
        <div className="col-xs-6">
          <a href="#" id="modal-nav-one-button" className="btn btn-block btn-main" style={{'whiteSpace': 'normal'}} onClick={onStepProgression}>
            {label}
          </a>
        </div>
      </div>
    )
  }

  function okButton() {
    return (
      <div className="row">
        <div className="col-xs-12">
          <a href="#" id="modal-nav-ok-button" className="btn btn-secondary radius-6" onClick={onStepProgression}>
            OK
          </a>
        </div>
      </div>
    )
  }

  function exitButton() {
    return (
      <div className="row">
        <div className="col-xs-12">
          <a href="#" className="btn btn-block btn-main modal-exit-button" onClick={onModalExit}>
            Exit
          </a>
        </div>
      </div>
    )
  }

  function skipButton() {
    return (
      <div className="row">
        <div className="col-xs-12">
          <a href="#" id="modal-nav-ok-button" className="btn btn-clear radius-6" onClick={onStepProgression}>
            Skip
          </a>
        </div>
      </div>
    )
  }

  function upButton() {
    return(
      <div className="up-button-footer pt30 pb30" style={{ position: 'absolute' }}>
        <span className='pl4 pull-left'>
          <a href="#" className="btn btn-lg btn-clear" id="modal-nav-up-button" onClick={onStepRetreat}>
            <i className='ficon-arrow-left fs14' />
          </a>
        </span>
      </div>
    )
  }

  function downButton() {
    return(
      <div className="down-button-footer pt30" style={{ position: 'absolute' }}>
        <span className='pull-left'>
          <a href="#" className="btn btn-lg" id="modal-nav-down-button" onClick={onStepProgression}>
            <i className='ficon-arrow-right fs14'/>
          </a>
        </span>
      </div>
    )
  }

  function upAndDownButton() {
    return(
      <div className="up-and-down-button-footer pt30" style={{ position: 'absolute' }}>
        <span className='pl4 pull-left'>
          <a href="#" className="btn btn-lg btn-clear" id="modal-nav-up-button" onClick={onStepRetreat}>
            <i className='ficon-arrow-left fs14' />
          </a>
        </span>
        <span className='pull-left'>
          <a href="#" className="btn btn-lg" id="modal-nav-down-button" onClick={onStepProgression}>
            <i className='ficon-arrow-right fs14'/>
          </a>
        </span>
      </div>
    )
  }

  return layoutChooser[navButtonLayout]()
}
